import { useState } from "react";
import { api, formatApiErrorDetail } from "@/lib/api";
import { labelCls, inputCls, primaryBtn, linkBtn, errorCls } from "./diaryStyles";

export const ForgotPasswordForm = ({ defaultIdentifier, onBack }) => {
  const [ident, setIdent] = useState(defaultIdentifier || "");
  const [sent, setSent] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!ident.trim()) { setError("Enter your username or email."); return; }
    setError(""); setLoading(true);
    try {
      const res = await api.post("/auth/forgot-password", { identifier: ident.trim() });
      setSent(res.data.message);
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail) || "Could not send the email. Please try again.");
    } finally { setLoading(false); }
  };

  return (
    <form onSubmit={submit} data-testid="diary-forgot-password-form">
      <h3 className="mb-4 font-serif text-2xl text-[#FBF4E8]">Forgot your password?</h3>
      <label className={labelCls}>Username or email</label>
      <input data-testid="diary-forgot-identifier" value={ident} onChange={(e) => setIdent(e.target.value.trim())} placeholder="Username or email" className={inputCls} />
      {error && <p data-testid="diary-forgot-error" className={errorCls}>{error}</p>}
      {sent && <p data-testid="diary-forgot-sent" className="mt-3 rounded-md bg-white/5 p-3 text-xs leading-relaxed text-[#F3E3C0]">{sent}</p>}
      <button data-testid="diary-forgot-submit" type="submit" disabled={loading || !!sent} className={primaryBtn}>{loading ? "Sending…" : "Email me a reset link"}</button>
      <button data-testid="diary-forgot-back" type="button" onClick={onBack} className={`${linkBtn} mt-3 block`}>Back to sign in</button>
    </form>
  );
};
